export default [
    {
        type: 1,
        label: {
            en: 'Individual',
            et: 'Eraisik',
            ru: 'Частное лицо',
            lv: "Privātpersona",
            lt: "Fizinis asmuo",
            fi: "Yksityishenkilö",
        },
    },
    {
        type: 2,
        label: {
            en: 'Company',
            et: 'Ettevõte',
            ru: 'Компания',
            lv: "Uzņēmums",
            lt: "Įmonė",
            fi: "Yritys",
        },
    },
]